import React, { useEffect, useState } from "react";
import "../styles/DomainList.css";
import DomainItem from "./DomainItem";
import DomainService from "../../services/DomainService";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import CustomTextModal from "../micro_components/CustomTextModal";

//loader
import { css } from "@emotion/react";
import SyncLoader from "react-spinners/SyncLoader";

const override = css`
  position: abolute;
  left: vh;
`;

const loadingColor = "#8C9BD8";

const DomainList = (props) => {
  const [domains, setDomains] = useState();
  const [addDomainModalOpen, setAddModalOpen] = useState(false);
  const [newName, setNewName] = useState("");

  let [loading, setLoading] = useState(true);

  useEffect(() => {
    DomainService.getAll()
      .then((response) => {
        setDomains(response.data);
        setLoading(false);
      })

      .catch((e) => {
        console.log("error getting all domains " + e);
        setLoading(false);
      });
  }, []);

  const loadDomains = () => {
    DomainService.getAll()
      .then((response) => {
        console.log("domains: ", response.data);
        setDomains(response.data);
      })
      .catch((e) => console.log("error getting all domains " + e));
  };

  const submitDomainName = () => {
    const newDomain = {
      name: newName,
      // webaddress: "",
    };
    DomainService.create(newDomain)
      .then((response) => {
        setAddModalOpen(false);
        loadDomains();
      })
      .catch((e) => console.log("error creating domain " + e));
  };

  const openAddDomainModal = () => {
    setAddModalOpen(true);
  };

  const closeAddDomainModal = () => {
    setAddModalOpen(false);
  };

  const changeNewDomainName = (event) => {
    setNewName(event.target.value);
  };

  //   const setDomain = (domain) => {
  //     domainService
  //       .updateDomain(domain.id, domain)
  //       .then((response) => {
  //         console.log(response.data);
  //       })
  //       .catch((e) => console.log("error setting domain " + e));
  //   };

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "40vh",
          }}
        >
          <SyncLoader color={loadingColor} loading={loading} css={override} style={{ marginLeft: "auto auto" }} />
        </div>
      ) : (
        <>
          <div className="domain-list">
            <h1>Domains</h1>
            <div className="create-new-domain-box">
              <h4>Create New Domain</h4>
              <IconButton aria-label="create" style={{ marginLeft: "50px" }} onClick={openAddDomainModal}>
                <CreateIcon fontSize="large" color="primary" />
              </IconButton>
            </div>
            <div>
              <CustomTextModal
                title={"Add New Domain"}
                isOpen={addDomainModalOpen}
                onClose={closeAddDomainModal}
                changeField={changeNewDomainName}
                onSubmit={submitDomainName}
                initial={""}
              />
            </div>
            {domains &&
              domains.map((domain, index) => {
                return <DomainItem key={index} initialDomain={domain} loadDomains={loadDomains} />;
              })}
          </div>
        </>
      )}
    </>
  );
};

export default DomainList;
